import { CxEvent } from '@spartacus/core';

export class Ga4GgProductPageEvent extends CxEvent {
  event?: string;
  visitor_type?: string;
  ecommerce?: {
    currency?: string;
    value?: number;
    items?: {
      item_id?: string;
      item_name?: string;
      item_list_name?: string;
      price?: number;
      quantity?: number;
    }[];
  } | null;
}
